/**
 * Carrega um icone de bootstrap-icons.
 * @param {string} icon Nome da icon a ser carregado, opções https://icons.getbootstrap.com.
 * @returns {string | undefined} O nome completo do ícone.
 */
const loadIcon = (icon: string): string | undefined => {
  return `bi bi-${icon}`
}

export default loadIcon
